/*
 * Copyright Mimic Networks, Inc. 2025.
 */

// This function will return whatever the MIMIC_MGMT_PLANE_ENVIRONMENT env var is, or 'local' if it is not set.
export function mimicEnv() {
  if (window.mimicConfig?.MIMIC_MGMT_PLANE_ENVIRONMENT) {
    return String(window.mimicConfig.MIMIC_MGMT_PLANE_ENVIRONMENT);
  }
  return 'local';
}

// Plugins (extensibility) are hidden in customer-facing envs until the feature is GA.
const PLUGINS_HIDDEN_ENVS = new Set(['uat', 'prod']);

export function arePluginsEnabled() {
  return !PLUGINS_HIDDEN_ENVS.has(mimicEnv());
}

// Dashcam's origin per environment (ENG-4578). Only prod and qa run a Dashcam;
// every other env has none (gov is also out of scope, PLAT-1397), so null tells
// callers to render nothing rather than link to a host that doesn't exist.
// A Map, not an object literal: an env name like "constructor" or "toString"
// must not match an inherited object property and count as a Dashcam.
const DASHCAM_ORIGINS = new Map<string, string>([
  ['prod', 'https://dashcam.mimic.com'],
  ['qa', 'https://dashcam.qa.mimic.com'],
]);

export function dashcamOrigin(): string | null {
  return DASHCAM_ORIGINS.get(mimicEnv()) ?? null;
}

export function isDashcamEnabled() {
  return dashcamOrigin() !== null;
}
